/**
 * Funciones de ayuda para la Facturacion
 * 
 */


/**
 * @param datosPagador datos del pagador completos
 * @returns datos del pagador filtrados y en el formato adecuado
 */
 export const datosPagadorFormato = (datosPagador) => {
  // primer día del mes o fecha de nacimiento
  const today = new Date();
  let  firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  let fechaNacimiento = datosPagador.cliFechaNacimiento;
  if (fechaNacimiento !== undefined && fechaNacimiento !== null) {
    fechaNacimiento = fechaNacimiento.split("/", 3);
    firstDayOfMonth = new Date(
      fechaNacimiento[2],
      fechaNacimiento[1],
      fechaNacimiento[0]
    );
  }
  // datos pagador
  const datosPagadorObj = {
    cliPersoneria: datosPagador === "" || datosPagador === undefined ? "" : datosPagador.cliPersoneria,
    cedula: datosPagador === "" || datosPagador === undefined ? "" : datosPagador.cliIdentificacion,
    codTipodocumento: datosPagador === "" || datosPagador === undefined ? "" : datosPagador.cliCodigoTipoDocumento,
    cliNombres: datosPagador === "" || datosPagador === undefined ? "" : datosPagador.cliNombres,
    cliApellidos: datosPagador === "" || datosPagador === undefined ? "" : datosPagador.cliApellidos,
    correo: datosPagador === "" || datosPagador === undefined? "" : datosPagador.cliEmail,
    direccion: datosPagador === "" || datosPagador === undefined ? "" : datosPagador.cliDireccion,
    celular: datosPagador === "" || datosPagador === undefined   ? ""  : datosPagador.cliCelular,
    codEstadoCivil: datosPagador === "" || datosPagador === undefined   ? null  : datosPagador.cliCodigoEstadoCivil,
    codGenero: datosPagador === "" || datosPagador === undefined   ? ""  : datosPagador.cliCodGenero,
    codProvincia: datosPagador === "" || datosPagador === undefined   ? ""  : datosPagador.cliCodigoProvincia,
    codCiudad: datosPagador === "" || datosPagador === undefined   ? ""  : datosPagador.cliCodigoCiudad,
    fechaNacimiento: firstDayOfMonth
   }

   return datosPagadorObj;
 }



 /**
 * @param datosPagador datos del pagador completos
 * @returns datos de la facturacion filtrados y en el formato adecuado
 */
  export const datosFacturacionFormato = (datosPagador) => {

    // primer día del mes o fecha de nacimiento
    const today = new Date();
    let  firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    let fechaNacimiento = datosPagador.cliFechaNacimiento;
    if (fechaNacimiento !== undefined && fechaNacimiento !== null) {
      fechaNacimiento = fechaNacimiento.split("/", 3);
      firstDayOfMonth = new Date(
        fechaNacimiento[2],
        fechaNacimiento[1],
        fechaNacimiento[0]
      );
    }

    // datos facturacion
    const datosFacturacionObj = {
      cliPersoneria: datosPagador === "" || datosPagador === undefined   ? ""   : datosPagador.cliPersoneria,
      cedula: datosPagador === "" || datosPagador === undefined   ? ""   : datosPagador.cliIdentificacion,
      codTipodocumento: datosPagador === "" || datosPagador === undefined   ? ""   : datosPagador.cliCodigoTipoDocumento,
      cliNombres: datosPagador === "" || datosPagador === undefined   ? ""   : datosPagador.cliNombres,
      cliApellidos: datosPagador === "" || datosPagador === undefined   ? ""   : datosPagador.cliApellidos,
      correo: datosPagador === "" || datosPagador === undefined   ? ""   : datosPagador.cliEmail,
      direccion: datosPagador === "" || datosPagador === undefined   ? ""   : datosPagador.cliDireccion,
      celular: datosPagador === "" || datosPagador === undefined   ? ""   : datosPagador.cliCelular,
      codEstadoCivil: datosPagador === "" || datosPagador === undefined   ? ""   : datosPagador.cliCodigoEstadoCivil,
      codGenero: datosPagador === "" || datosPagador === undefined   ? ""   : datosPagador.cliCodGenero,
      codProvincia: datosPagador === "" || datosPagador === undefined   ? ""   : datosPagador.cliCodigoProvincia,
      codCiudad: datosPagador === "" || datosPagador === undefined   ? ""   : datosPagador.cliCodigoCiudad,
      fechaNacimiento: firstDayOfMonth,
    }

     return datosFacturacionObj;
   }

  export const separarNombres = (texto) => {
    if (!texto) return ["", ""];

    const limpio = texto.trim().replace(/\s+/g, " ");
    const partes = limpio.split(" ");

    if (partes.length === 1) return [partes[0], ""];

    return [partes[0], partes.slice(1).join(" ")];
  }